/**
 * src/i18n/holidays-ja.js
 */

var holidaysList = {
    2012: { 
      '01-01': true,
      '01-02': true,
      '01-09': true,
      '02-11': true,
      '03-20': true,
      '04-29': true,
      '04-30': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '07-16': true,
      '09-17': true,
      '09-22': true,
      '10-08': true,
      '11-03': true,
      '11-23': true,
      '12-23': true,
      '12-24': true,
    },
    2013: { 
      '01-01': true,
      '01-14': true,
      '02-11': true,
      '03-20': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '05-06': true,
      '07-15': true,
      '09-16': true,
      '09-23': true,
      '10-14': true,
      '11-03': true,
      '11-04': true,
      '11-23': true,
      '12-23': true,
    },
    2014: { 
      '01-01': true,
      '01-13': true,
      '02-11': true,
      '03-21': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '05-06': true,
      '07-21': true,
      '09-15': true,
      '09-23': true,
      '10-13': true,
      '11-03': true,
      '11-23': true,
      '11-24': true,
      '12-23': true,
    },
    2015: {
      '01-01': true,
      '01-12': true,
      '02-11': true,
      '03-21': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '05-06': true,
      '07-20': true,
      '09-21': true,
      '09-22': true,
      '09-23': true,
      '10-12': true,
      '11-03': true,
      '11-23': true,
      '12-23': true,
    },
    2016: {
      '01-01': true,
      '01-11': true,
      '02-11': true,
      '03-20': true,
      '03-21': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '07-18': true,
      '08-11': true,
      '09-19': true,
      '09-22': true,
      '10-10': true,
      '11-03': true,
      '11-23': true,
      '12-23': true,
    },
    2017: {
      '01-01': true,
      '01-02': true,
      '01-09': true,
      '02-11': true,
      '03-20': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '07-17': true,
      '08-11': true,
      '09-18': true,
      '09-23': true,
      '10-09': true,
      '11-03': true,
      '11-23': true,
      '12-23': true,
    },
    2018: {
      '01-01': true,
      '01-08': true,
      '02-11': true,
      '02-12': true,
      '03-21': true,
      '04-29': true,
      '04-30': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '07-16': true,
      '08-11': true,
      '09-17': true,
      '09-23': true,
      '09-24': true,
      '10-08': true,
      '11-03': true,
      '11-23': true,
      '12-23': true,
      '12-24': true,
    },
    2019: {
      '01-01': true,
      '01-14': true,
      '02-11': true,
      '03-21': true,
      '04-29': true,
      '04-30': true,
      '05-01': true,
      '05-02': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '05-06': true,
      '07-15': true,
      '08-11': true,
      '08-12': true,
      '09-16': true,
      '09-23': true,
      '10-14': true,
      '10-22': true,
      '11-03': true,
      '11-04': true,
      '11-23': true,
    },
    2020: {
      '01-01': true,
      '01-13': true,
      '02-11': true,
      '02-23': true,
      '02-24': true,
      '03-20': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '05-06': true,
      '07-23': true,
      '07-24': true,
      '08-10': true,
      '09-21': true,
      '09-22': true,
      '11-03': true,
      '11-23': true,
    },
    2021: {
      '01-01': true,
      '01-11': true,
      '02-11': true,
      '02-23': true,
      '03-20': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '07-19': true,
      '08-11': true,
      '09-20': true,
      '09-23': true,
      '10-11': true,
      '11-03': true,
      '11-23': true,
    },
    2022: {
      '01-01': true,
      '01-10': true,
      '02-11': true,
      '02-23': true,
      '03-21': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '07-18': true,
      '08-11': true,
      '09-19': true,
      '09-23': true,
      '10-10': true,
      '11-03': true,
      '11-23': true,
    },
    2023: {
      '01-01': true,
      '01-02': true,
      '01-09': true,
      '02-11': true,
      '02-23': true,
      '03-21': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '07-17': true,
      '08-11': true,
      '09-18': true,
      '09-23': true,
      '10-09': true,
      '11-03': true,
      '11-23': true,
    },
    2024: {
      '01-01': true,
      '01-02': true,
      '01-08': true,
      '02-11': true,
      '02-12': true,
      '02-23': true,
      '03-20': true,
      '04-29': true,
      '05-03': true,
      '05-04': true,
      '05-05': true,
      '05-06': true,
      '07-15': true,
      '08-11': true,
      '08-12': true,
      '09-16': true,
      '09-22': true,
      '09-23': true,
      '10-14': true,
      '11-03': true,
      '11-04': true,
      '11-23': true,
    },
  } 

  export default holidaysList;


// WEBPACK FOOTER //
// ./src/i18n/holidays-ja.js